import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { CatalogSort } from '@/data/catalog/search';
import { useCatalogFilters } from '@/packages/courses/context/catalog-filters';
import type { FilterSchemaInlineSelect } from '@/packages/courses/types/schema';

export const FilterInlineSelect = ({
  id,
  title,
  placeholder,
  options,
  defaultValue,
}: FilterSchemaInlineSelect) => {
  const { params, actions } = useCatalogFilters();
  const value = params[id]?.[0] ?? defaultValue;

  const handleChange = (event: { target: { value: string } }) => {
    const v = event.target.value as CatalogSort;
    actions.setParam(id, v);
  };

  const labelId = `${id}-label`;

  return (
    <FormControl fullWidth size="small">
      <InputLabel id={labelId}>
        {title}
      </InputLabel>
      <Select
        labelId={labelId}
        id={id}
        name={id}
        label={title}
        value={value}
        onChange={handleChange}
        displayEmpty
        renderValue={(v) =>
          options.find((o) => o.value === v)?.label ?? placeholder
        }
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
